import { RiArrowDownSLine } from 'react-icons/ri';

import palette from '@lib/core/src/theme/palette';
import { MenuItem, Select, styled, Typography } from '@mui/material';

import { QuarterYear } from '@/utils/dateUtil';
import { useIsSmallScreen } from '@/utils/mediaUtil';

export const PeriodDropdownWrapper = styled(Select)(() => ({
  width: '80px',
  padding: '0',
  height: '42px',
  borderRadius: '8px',
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none',
    padding: '0'
  },
  '& .MuiSelect-select': {
    padding: '0'
  }
}));

export const GoalsTitle = styled(Typography)(() => ({
  color: palette.black,
  fontSize: '13px',
  fontWeight: 600
}));

interface PeriodDropdownProps {
  periods: QuarterYear[];
  selectedPeriod: QuarterYear;
  onPeriodChange: (period: QuarterYear) => void;
}

const PeriodDropdownComponent = ({
  periods,
  selectedPeriod,
  onPeriodChange
}: PeriodDropdownProps) => {
  const isSmallScreen = useIsSmallScreen();
  return (
    <PeriodDropdownWrapper
      sx={{ ...(!isSmallScreen && { alignSelf: 'flex-start' }) }}
      onChange={event => {
        const values = (event.target.value as string).split(':');
        onPeriodChange({
          quarter: parseInt(values[0]),
          year: parseInt(values[1])
        });
      }}
      value={`${selectedPeriod.quarter}:${selectedPeriod.year}`}
      IconComponent={RiArrowDownSLine}
      MenuProps={{
        PaperProps: {
          sx: {
            border: `1px solid ${palette.grey[100]}`,
            borderRadius: '8px',
            '& p': {
              fontSize: '12px',
              fontWeight: 500,
              color: palette.black
            }
          }
        }
      }}
    >
      {periods.map((period, index) => (
        <MenuItem
          key={index}
          sx={{
            padding: '5px 0px',
            justifyContent: 'center',
            borderBottom: `1px solid ${palette.grey[100]}`,
            '&:last-child': {
              borderBottom: 'none'
            }
          }}
          value={`${period.quarter}:${period.year}`}
        >
          <GoalsTitle>
            Q{period.quarter} {period.year}
          </GoalsTitle>
        </MenuItem>
      ))}
    </PeriodDropdownWrapper>
  );
};

export default PeriodDropdownComponent;
